import { VisitInfo } from '../models/guestInvestorModel';
import { useNavigate } from 'react-router-dom';
import { VisitPreSaleState } from '../../../constants/visitsConstants';
import AdminListGroup, {
  DisplayItem,
} from '../../../components/admin/AdminListGroup';

import InvestorVisitsBadge from '../../../components/badges/InvestorVisitsBadge';

interface Props {
  guestVisit: VisitInfo;
}

const InvestorVisitDetailCard = ({ guestVisit }: Props) => {
  const navigate = useNavigate();
  const toGuestVisitEdit = () =>
    navigate(`/investors/guest/visits/${guestVisit.id}/edit`);

  const fieldMapper: DisplayItem[] = [
    {
      title: 'Estado',
      value: <InvestorVisitsBadge status={guestVisit.visit_status} />,
    },
    {
      title: 'Origen',
      value: `${guestVisit.visit_source} - ${guestVisit.visit_owner}`,
    },
    {
      title: 'Tipo',
      value: guestVisit.visit_type === 'presential' ? 'Presencial' : 'Virtual',
    },
    {
      title: 'Fecha y hora',
      value: `${guestVisit.visit_date} ${guestVisit.visit_time}`,
      href:
        guestVisit.visit_status === VisitPreSaleState.PENDING_APPROVAL ||
        (!guestVisit.visit_proper_selected_id &&
          guestVisit.visit_status === VisitPreSaleState.SCHEDULED)
          ? `/investors/guest/visits/${guestVisit.id}/edit`
          : undefined,
    },
  ];

  return <AdminListGroup title={'Asesoría'} items={fieldMapper} />;
};

export default InvestorVisitDetailCard;
